import { CALENDAR_SELECTIONS_SESSION_STORAGE_KEY } from '../storeCalendarSelections/storeCalendarSelections';
export const extractCalendarSelections = async _ref => {
  let {
    session
  } = _ref;
  const calendarSelections = session.getItem(CALENDAR_SELECTIONS_SESSION_STORAGE_KEY);
  if (!calendarSelections) {
    return;
  }
  return JSON.parse(calendarSelections);
};
export const extractCalendarSelectionsForService = async _ref2 => {
  let {
    session,
    serviceId
  } = _ref2;
  const allCalendarSelections = await extractCalendarSelections({
    session
  });
  if (!serviceId || !allCalendarSelections) {
    return undefined;
  }
  const matchingService = allCalendarSelections.services.find(service => service.id === serviceId);
  return matchingService ? {
    location: allCalendarSelections.location,
    services: [matchingService]
  } : undefined;
};
//# sourceMappingURL=extractCalendarSelections.js.map